import * as React from 'react';

// eslint-disable-next-line @gandi/gandi/no-private-import

export const fieldConfigKeys = ['afterSubmit', 'allowNull', 'beforeSubmit',
// component & children are excluded because it's directly injected here
// 'children',
// 'component',
'data', 'defaultValue', 'format', 'formatOnBlur', 'initialValue', 'isEqual', 'multiple', 'parse', 'type', 'validate', 'validateFields', 'value'];
export const groupPropKeys = ['addon', 'disabled', 'error', 'help', 'id', 'label', 'legend', 'optional', 'popoverIcon', 'required', 'warning'];